import { memo } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const TopLeftMenu = () => {
  const userInfo = useSelector((state) => state.authReducer.data);
  console.log('userInfo...', userInfo);

  const activeDoctor = useSelector(
    (state) => state.doctorsOfAssistantReducer.activeDoctor,
  );
  const url = window.location.pathname.substr(1);
  const MenuLabel = ({ menuTitle, item }) => {
    return (
      <span style={{ fontWeight: 'bold', fontSize: '26px' }}>{menuTitle}</span>
    );
  };

  return (
    <div className="left-side-pres">
      <div style={{ width: '73px' }}></div>
      {userInfo.userType !== 'assistant' && (
        <Link
          className={`nav-link ${
            url === 'prescription' ? 'small_menu_item active' : ''
          }`}
          to="/prescription"
          title="Rx"
        >
          <span className="nav_button">Rx</span>
          {/* <MenuLabel menuTitle="Rx" item={'prescription'} /> */}
        </Link>
      )}
      <Link
        className={`nav-link ${
          url === 'appointments' || url === 'new-appointment'
            ? 'small_menu_item active'
            : ''
        }`}
        to="/appointments"
        title="Appointments"
      >
        {/* <i className="far fa-calendar-alt fa-1x stat-icon"></i> */}
        {/* <img src={appointmentIcon} alt="Appointments" /> */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-calendar-plus"
          viewBox="0 0 16 16"
          style={{ height: '26px', width: '26px' }}
        >
          <path d="M8 7a.5.5 0 0 1 .5.5V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5A.5.5 0 0 1 8 7" />
          <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
        </svg>
      </Link>
      {userInfo.userType === 'assistant' &&
        activeDoctor.doctorDetails?.smsModule && (
          <Link
            className={`nav-link ${
              url === 'send-sms' ? 'small_menu_item active' : ''
            }`}
            to="/send-sms"
            title="SMS"
          >
            {/* <i className="fas fa-fw fa-envelope"></i> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              style={{ height: '26px', width: '26px' }}
              fill="currentColor"
              class="bi bi-envelope-fill"
              viewBox="0 0 16 16"
            >
              <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z" />
            </svg>
          </Link>
        )}
      {userInfo.userType !== 'assistant' && (
        <>
          <Link
            className={`nav-link ${
              url === 'patients' ? 'small_menu_item active' : ''
            }`}
            to="/patients"
            title="Patients"
          >
            {/* <i className="fa fa-users"></i> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              style={{ height: '26px', width: '26px' }}
              fill="currentColor"
              class="bi bi-people-fill"
              viewBox="0 0 16 16"
            >
              <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
            </svg>
          </Link>
          <Link
            className={`nav-link ${
              url === 'home' ? 'small_menu_item active' : ''
            }`}
            to="/home"
            title="Reports"
          >
            {/* <i className="fas fa-chart-bar"></i> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              style={{ height: '26px', width: '26px' }}
              fill="currentColor"
              class="bi bi-bar-chart-line-fill"
              viewBox="0 0 16 16"
            >
              <path d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1z" />
            </svg>
          </Link>
          {userInfo.doctorDetails?.smsModule && (
            <Link
              className={`nav-link ${
                url === 'send-sms' ? 'small_menu_item active' : ''
              }`}
              to="/send-sms"
              title="SMS"
            >
              {/* <i className="fas fa-fw fa-envelope"></i> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style={{ height: '26px', width: '26px' }}
                fill="currentColor"
                class="bi bi-envelope-fill"
                viewBox="0 0 16 16"
              >
                <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z" />
              </svg>
            </Link>
          )}

          {userInfo && userInfo?.doctorDetails?.otEnabled && (
            <Link
              className={`nav-link ${
                url === 'ot-list' ||
                url === 'new-ot-entry' ||
                url === 'edit-ot-entry'
                  ? 'small_menu_item active'
                  : ''
              }`}
              to="/ot-list"
              title="OT List"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style={{ height: '26px', width: '26px' }}
                fill="currentColor"
                viewBox="0 0 24 22"
              >
                {/* IV hook */}
                <path d="M2 2 Q2 0.2 3.5 0.2 Q5 0.2 5 2 Q5 3 3.5 3 L3.2 3 L3.2 14 L2.2 14 L2.2 3 L2 3 Z" />
                {/* IV bag */}
                <rect x="0.8" y="3" width="3.8" height="5" rx="0.8" />
                {/* IV tube */}
                <rect x="2.4" y="8" width="0.7" height="6" />
                {/* Bed top rail */}
                <rect x="2" y="13.5" width="21.5" height="1" rx="0.3" />
                {/* Bed left post */}
                <rect x="2" y="13" width="1" height="4" rx="0.2" />
                {/* Headboard right */}
                <rect x="22" y="11" width="1.8" height="5.5" rx="0.4" />
                {/* Mattress */}
                <rect x="2.8" y="14.5" width="19" height="2.5" rx="0.4" />
                {/* Underframe */}
                <rect x="4.5" y="17" width="15.5" height="2" rx="0.4" />
                {/* Left wheel */}
                <circle cx="7.5" cy="20.3" r="1.4" />
                {/* Right wheel */}
                <circle cx="19" cy="20.3" r="1.4" />
                {/* Patient head */}
                <circle cx="19.5" cy="12" r="2.3" />
                {/* Patient body on bed */}
                <path d="M3.5 15.8 Q11 13.8 17.5 14.8 L17.5 15.5 Q11 14.5 3.5 16.5 Z" />
              </svg>
            </Link>
          )}
          <Link
            className={`nav-link ${
              url === 'settings' ? 'small_menu_item active' : ''
            }`}
            to="/settings"
            title="Settings"
          >
            {/* <i className="fas fa-fw fa-cog"></i> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              style={{ height: '26px', width: '26px' }}
              fill="currentColor"
              class="bi bi-gear-fill"
              viewBox="0 0 16 16"
            >
              <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z" />
            </svg>
          </Link>
        </>
      )}
      {(userInfo?.userType === 'assistant'
        ? activeDoctor?.doctorDetails?.appointmentAdToken
        : userInfo?.doctorDetails?.appointmentAdToken) && (
        <Link
          className={`nav-link ${
            url === 'announces' ? 'small_menu_item active' : ''
          }`}
          to="/announces"
          title="Announcements"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{ height: '26px', width: '26px' }}
            fill="currentColor"
            className="bi bi-megaphone-fill"
            viewBox="0 0 16 16"
          >
            <path d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-.214c-2.162-1.241-4.49-1.843-6.912-2.083l.405 2.712A1 1 0 0 1 5.51 15.1h-.548a1 1 0 0 1-.916-.599l-1.85-3.49-.202-.003A2.014 2.014 0 0 1 0 9V7a2.02 2.02 0 0 1 1.992-2.013 74.663 74.663 0 0 0 2.483-.075c3.043-.154 6.148-.849 8.525-2.199V2.5zm1 0v11a.5.5 0 0 0 1 0v-11a.5.5 0 0 0-1 0zm-1 1.35c-2.344 1.205-5.209 1.842-8 2.033v4.233c.18.01.359.022.537.036 2.568.189 5.093.744 7.463 1.993V3.85zm-9 6.215v-4.13a95.09 95.09 0 0 1-1.992.052A1.02 1.02 0 0 0 1 7v2c0 .55.448 1 .996 1a95.09 95.09 0 0 1 1.004-.013zm-.692 1.193 1.62 3.054H5.51l-.47-3.143a82.088 82.088 0 0 0-.732-.017l.004.016c-.026-.005-.054-.01-.081-.01h-.003z" />
          </svg>
        </Link>
      )}
    </div>
  );
};

export default memo(TopLeftMenu);
